/**
 * API layers may return `error` as a string or `{ type, message }` (RTK Query / axios).
 * Never pass the raw value to React children — use this helper for user-facing strings.
 */
export function normalizeOmmnioSignError(err, fallbackMessage) {
  const nested = err?.data?.error ?? err?.response?.data?.error;
  const topMsg = err?.data?.message ?? err?.response?.data?.message;

  const message = value =>
    typeof value === 'string' && value.length > 0 ? value.replace(/^Error:\s*/, '') : null;

  if (nested != null && typeof nested === 'object') {
    if (message(nested.message)) return message(nested.message);
    if (typeof nested.type === 'string') return nested.type;
    if (message(topMsg)) return message(topMsg);
    return fallbackMessage;
  }
  if (message(nested)) return message(nested);
  if (message(topMsg)) return message(topMsg);
  if (message(err?.message)) return message(err.message);
  return fallbackMessage;
}
